import { css } from '@emotion/css';

import { colors } from '@ajaibid/components';

export const styHeaderBg = ({ isPremium, isPremiumTrial }) => css`
  background: ${isPremium || isPremiumTrial ? colors.SLATE_GRAY_7 : colors.AJAIB_BLUE_5};
  height: 54px;
`;

export const styTitleMsgBox = css`
  line-height: 20px;
`;

export const styTextMsgBox = css`
  font-size: 14px;
  line-height: 20px;
`;
